import { Link } from "react-router-dom";
import { BrandMark } from "@/components/Logo";
import { ShieldCheck, Flask, Barcode, Warning } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-cyan/15 bg-navy-deep">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 sm:grid-cols-2 sm:px-8 lg:grid-cols-4 lg:px-12">
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="mb-4 flex items-center gap-2.5 text-cyan">
            <BrandMark className="h-11 w-11" />
            <span className="font-heading text-lg font-black tracking-tight text-white">
              QuadHelix <span className="text-cyan">Labs</span>
            </span>
          </div>
          <p className="max-w-xs text-sm leading-relaxed text-teal-muted">
            Premium research peptides synthesized and tested to laboratory-grade purity.
            Third-party verified Certificates of Analysis included.
          </p>
        </div>

        <div>
          <h4 className="mb-4 font-mono text-xs uppercase tracking-widest text-cyan">Catalog</h4>
          <ul className="space-y-2.5 text-sm text-teal-muted">
            <li><Link to="/shop" className="transition-colors hover:text-white">All Peptides</Link></li>
            <li><Link to="/shop?category=Healing %26 Recovery" className="transition-colors hover:text-white">Healing & Recovery</Link></li>
            <li><Link to="/shop?category=Metabolic" className="transition-colors hover:text-white">Metabolic</Link></li>
            <li><Link to="/shop?category=Longevity" className="transition-colors hover:text-white">Longevity</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-mono text-xs uppercase tracking-widest text-cyan">Account</h4>
          <ul className="space-y-2.5 text-sm text-teal-muted">
            <li><Link to="/login" className="transition-colors hover:text-white">Sign In</Link></li>
            <li><Link to="/register" className="transition-colors hover:text-white">Create Account</Link></li>
            <li><Link to="/account" className="transition-colors hover:text-white">My Orders</Link></li>
            <li><Link to="/cart" className="transition-colors hover:text-white">Cart</Link></li>
            <li><Link to="/contact" className="transition-colors hover:text-white">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-mono text-xs uppercase tracking-widest text-cyan">Assurance</h4>
          <ul className="space-y-3 text-sm text-teal-muted">
            <li className="flex items-center gap-2"><ShieldCheck size={16} className="text-cyan" /> &gt;99% Verified Purity</li>
            <li className="flex items-center gap-2"><Flask size={16} className="text-cyan" /> COA per Batch</li>
            <li className="flex items-center gap-2"><Barcode size={16} className="text-cyan" /> Batch Traceability</li>
          </ul>
        </div>
      </div>

      {/* FDA Compliance & Warning */}
      <div className="border-t border-cyan/10 bg-navy-deep">
        <div className="mx-auto max-w-7xl px-6 py-8 sm:px-8 lg:px-12">
          <div
            data-testid="fda-warning"
            className="flex items-start gap-3 border border-amber-500/30 bg-amber-500/[0.06] p-5"
          >
            <Warning size={22} weight="fill" className="mt-0.5 shrink-0 text-amber-400" />
            <div>
              <h4 className="font-mono text-xs uppercase tracking-widest text-amber-400">
                FDA Compliance &amp; Warning
              </h4>
              <p className="mt-2 text-xs leading-relaxed text-teal-muted">
                All products sold by QuadHelix Labs are intended strictly for{" "}
                <span className="text-white">laboratory and research use only</span>. They are{" "}
                <span className="text-white">not for human or veterinary use</span> and are not
                intended to diagnose, treat, cure, or prevent any disease. These statements have not
                been evaluated by the U.S. Food and Drug Administration (FDA). No product offered is a
                drug, food, cosmetic, or dietary supplement, and none may be administered to humans or
                animals. By purchasing, you confirm that you are a qualified researcher and agree to
                handle, store, and dispose of all compounds in accordance with all applicable federal,
                state, and local laws and institutional guidelines.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-cyan/10 px-6 py-6">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 text-center sm:flex-row sm:text-left">
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-teal/70">
            © {new Date().getFullYear()} QuadHelix Labs — Research Use Only · Not for Human Consumption
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-teal/70">
            Built for qualified researchers
          </p>
        </div>
      </div>
    </footer>
  );
}
